// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staging-toolbar[data-v-1ab71d61] {
  position: relative;
}
.staging-toolbar-center[data-v-1ab71d61] {
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/create-dashboard/CreateToolbar.vue","webpack://./CreateToolbar.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;ACDF;ADIA;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.staging-toolbar {\n  position: relative;\n}\n\n.staging-toolbar-center {\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n}\n",".staging-toolbar {\n  position: relative;\n}\n\n.staging-toolbar-center {\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
